module.exports = __webpack_public_path__ + "static/media/left_hover.1b4651d1.svg";